import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { message } from 'antd';
import { apiGetRegistrationInfo } from 'services/dashboardService';
import { UpdateAppInfo } from 'redux/actions/appActions';
import { updateUser } from 'redux/actions/userActions';

console.log("Module 'useRegistrationData.js' is being loaded.");

// Define a constant for the open status to improve readability and avoid "magic values".
const REGISTRATION_OPEN_STATUS = '1';

export const useRegistrationData = () => {
  const dispatch = useDispatch();
  const [isBusy, setIsBusy] = useState(true);
  const [resStatus, setRecStatus] = useState(false);
  const [curDomain, setCurDomain] = useState('');

  useEffect(() => {
    const fetchRegistrationData = async () => {
      let domain = window.location.hostname;
      if (process.env.NODE_ENV === 'development') {
        // For local development, use the dev domain from .env
        domain = process.env.REACT_APP_DEV_DOMAIN;
      } else {
        // For production builds, use the specific registration domain from .env
        domain = process.env.REACT_APP_REGISTRATION_DOMAIN;
      }

      if (!domain) {
        console.error("FATAL: Domain could not be determined. For local development, ensure REACT_APP_DEV_DOMAIN is set in your .env file.");
        setIsBusy(false);
        return;
      }

      console.log('Fetching registration info for domain:', domain);
      setCurDomain(domain);

      // Reset Redux state on page load
      dispatch(UpdateAppInfo({ appInfo: undefined }));
      dispatch(updateUser({ token: undefined }));

      try {
        const res = await apiGetRegistrationInfo(domain);
        console.log('Registration Info API Response:', res);
        if (res.result) {
          dispatch(UpdateAppInfo({ appInfo: res.data }));
          if (res.data && res.data.registration_info) {
            setRecStatus(String(res.data.registration_info.status).trim() === REGISTRATION_OPEN_STATUS);
          } else {
            console.error("DEBUG: 'registration_info' object is missing from the API response data.");
            setRecStatus(false);
          }
        }
      } catch (err) {
        message.error('Something went wrong');
        setRecStatus(false); // Assume registration is closed on error
      } finally {
        setIsBusy(false);
      }
    };

    fetchRegistrationData();
  }, [dispatch]);

  return { isBusy, resStatus, curDomain };
};